import React, { FC } from "react";
import { Tabs } from "src/components/common";

type UserManagementTabsProps = {
	className?: string;
	location?: any;
};

export const UserManagementTabs: FC<UserManagementTabsProps> = ({
	className,
	location,
}) => {
	const createTabs = () => {
		return [
			{
				to: `/admin/users/`,
				label: `Users`,
			},
		];
	};

	const tabs = createTabs();
	return <Tabs className={className} tabs={tabs} location={location} />;
};
